<template>
  <div>
    <a-drawer
      :maskClosable="false"
      width="80%"
      title="维修分类"
      placement="right"
      :closable="true"
      :visible="visible"
      @close="onClose"
    >
      <a-card :bordered="false">
        <div class="table-operations">
          <template>
            <a-button type="primary" @click="handleAdd" v-hasPermi="['upkeep:category:tenant:add']">
              <a-icon type="plus" />新增
            </a-button>

            <a-button
              type="danger"
              :disabled="multiple"
              @click="handleBatchDelete"
              v-hasPermi="['upkeep:category:tenant:remove']"
            >
              <a-icon type="delete" />批量删除
            </a-button>

            <a-button type="primary" @click="handleExport" v-hasPermi="['upkeep:category:tenant:export']">
              <a-icon type="download" /> 导出
            </a-button>
          </template>
        </div>
        <a-table
          :loading="loading"
          rowKey="id"
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :row-selection="rowSelection"
        >
          <span slot="sort" slot-scope="text, record">
            {{ record.sort }}
          </span>
          <span slot="createTime" slot-scope="text, record">
            {{ record.createTime }}
          </span>
          <span slot="operation" slot-scope="text, record">
            <a @click="handleDelete(record)" v-hasPermi="['upkeep:category:tenant:remove']">删除</a>
          </span>
        </a-table>
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </a-card>
    </a-drawer>

    <!-- 新增/修改表单组件 -->
    <tenant-point-form ref="tenantPointForm" @ok="getList" />
  </div>
</template>

<script>
import { listTenantCategory, delTenantCategory } from '@/api/system/tenantCategory'
import { tableMixin } from '@/store/table-mixin'
import TenantPointForm from './tenantPointForm'

export default {
  mixins: [tableMixin],
  components: { TenantPointForm },
  data() {
    return {
      visible: false,
      list: [],
      loading: false,
      total: 0,
      selectedRowKeys: [],
      selectedRows: [],
      single: true,
      multiple: true,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        tenantId: undefined,
      },
      currentRecord: null,
      columns: [
        {
          title: '分类名称',
          dataIndex: 'name',
          align: 'center',
        },
        {
          title: '排序号',
          dataIndex: 'sort',
          align: 'center',
          scopedSlots: { customRender: 'sort' },
        },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   align: 'center',
        //   ellipsis: true
        // },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 150,
          align: 'center',
          scopedSlots: { customRender: 'operation' },
        },
      ],
    }
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        onSelect: this.onSelect,
        onSelectAll: this.onSelectAll,
      }
    },
  },
  methods: {
    handleExport() {
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk: () =>
          this.download(
            'upkeep/category/tenant/export',
            { ...this.queryParam },
            `维修分类关联租户列表_${new Date().getTime()}.xlsx`
          ),
      })
    },
    init(record) {
      this.visible = true
      this.currentRecord = record
      this.queryParam.tenantId = record.id
      this.getList()
    },
    onClose() {
      this.visible = false
      this.selectedRowKeys = []
      this.selectedRows = []
      this.currentRecord = null
    },
    getList() {
      this.loading = true
      listTenantCategory(this.queryParam)
        .then((res) => {
          this.list = res.data.records
          this.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    onSelect(record, selected, selectedRows) {
      this.selectedRows = selectedRows
    },
    onSelectAll(selected, selectedRows, changeRows) {
      this.selectedRows = selectedRows
    },
    handleAdd() {
      if (this.$refs.tenantPointForm && this.queryParam.tenantId) {
        this.$refs.tenantPointForm.handleAdd(this.queryParam.tenantId)
      }
    },
    handleEdit(record) {
      if (this.$refs.tenantPointForm) {
        // 这里可以根据需要传递已选中的分类ID
        const selectedIds = [record.id] // 如果是修改单个，可以这样传递
        this.$refs.tenantPointForm.handleUpdate(this.queryParam.tenantId, selectedIds)
      }
    },
    handleDelete(record) {
      const that = this
      this.$confirm({
        title: '确认删除',
        content: `是否确认删除分类"${record.name}"?`,
        onOk() {
          const deleteData = {
            ids: [record.id],
            tenantId: that.queryParam.tenantId,
          }

          return delTenantCategory(deleteData)
            .then(() => {
              that.getList()
              that.$message.success('删除成功')
            })
            .catch((error) => {
              console.error('删除失败:', error)
              that.$message.error('删除失败')
            })
        },
        onCancel() {},
      })
    },

    handleBatchDelete() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }

      const that = this
      this.$confirm({
        title: '确认批量删除',
        content: `确定要删除选中的 ${this.selectedRowKeys.length} 条数据吗？`,
        onOk() {
          const deleteData = {
            ids: that.selectedRowKeys,
            tenantId: that.queryParam.tenantId,
          }

          return delTenantCategory(deleteData)
            .then(() => {
              that.selectedRowKeys = []
              that.selectedRows = []
              that.getList()
              that.$message.success('删除成功')
            })
            .catch((error) => {
              console.error('批量删除失败:', error)
              that.$message.error('批量删除失败')
            })
        },
        onCancel() {},
      })
    },

    parseTime(time) {
      if (!time) return ''
      return this.$moment(time).format('YYYY-MM-DD HH:mm:ss')
    },
  },
}
</script>

<style scoped>
.ant-table-pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
